<template>
  <section class="form-fw__content">
    <div class="form__container">

      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        :loading="false"
        no-data-text="Nenhum resultado encontrato"
        no-results-text="Carregando dados..."
        :total-items="5"
      >
        <template v-slot:items="props">
          <td
            :class="[
              { 'success--text': props.item.status === 'Enviado' },
              { 'error--text': props.item.status === 'Erro' }
            ]"
          >
            {{ props.item.status }}
          </td>
          <td>
            <span>{{ props.item.date | formatDate('DD/MM/YYYY') }}</span><br>
            <span>{{ props.item.date | formatDate('HH:mm:ss') }}</span>
          </td>
          <td>{{ props.item.filename }}</td>
          <td :class="{ 'error--text': props.item.status === 'Erro' }">
            {{ props.item.linesCount }}
          </td>
        </template>
      </v-data-table>
    </div>

    <div class="text-xs-center">
    <!-- <div v-if="pagination.totalElements > pagination.itemsPerPage" class="text-xs-center"> -->
      <v-container class="pa-0">
        <v-pagination
          v-model="pagination.currentPage"
          color="accent"
          :total-visible="totalVisible"
          :length="pagination.totalPages"
          @input="handlePage"
        />
      </v-container>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Table',
  computed: {
    totalVisible () {
      return window.innerWidth <= 420 ? 5 : 7
    }
  },

  data () {
    return {
      pagination: {
        currentPage: 1,
        totalElements: 25,
        itemsPerPage: 25,
        totalPages: 52
      },
      namespace: 'Views.RevenuesPage',
      headers: [
        {
          text: 'Status',
          align: 'left',
          sortable: false,
          value: 'Status'
        },
        {
          text: 'Data',
          align: 'left',
          sortable: false,
          value: 'Data'
        },
        {
          text: 'Nome do arquivo',
          align: 'left',
          sortable: false,
          value: 'Nome do arquivo'
        },
        {
          text: 'Linhas importadas',
          align: 'left',
          sortable: false,
          value: 'Linhas importadas'
        }
      ],
      items: [
        {
          status: 'Enviado',
          date: '2019-12-20T23:00:00',
          filename: 'NFSe_RPS_48814652_20180901_20180930_1538430991123.csv',
          linesCount: 2000
        },
        {
          status: 'Erro',
          date: '2019-12-20T23:00:00',
          filename: 'NFSe_RPS_48814652_20180901_20180930_1538430991123.csv',
          linesCount: 2000
        },
        {
          status: 'Enviado',
          date: '2019-12-20T23:00:00',
          filename: 'NFSe_RPS_48814652_20180901_20180930_1538430991123.csv',
          linesCount: 2000
        },
        {
          status: 'Enviado',
          date: '2019-12-20T23:00:00',
          filename: 'NFSe_RPS_48814652_20180901_20180930_1538430991123.csv',
          linesCount: 2000
        }
      ]
    }
  },
  methods: {
    handlePage (page) {
      console.log(page)
    }
  }
}
</script>
